import MUIBox from '@/components/MUI-Components/MUI-Box';
import MUIGrid from '@/components/MUI-Components/MUI-Grid';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import dynamic from 'next/dynamic';
import {Fragment, memo} from 'react';
const DisplayImage = dynamic(import('@/components/Ui-components/display-image'), {ssr: false});
import Chip from '@/components/Common/Chip';
import parse from 'html-react-parser';
import {colors, fontFamily, fontSize, spacing} from '@/styles/tokens';

// Migrated from globals.scss `.process-chip` (single owner, this file).
const processChipStyle: React.CSSProperties = {
    marginTop: '20px',
    padding: '10px',
    fontFamily: fontFamily.heading,
    fontSize: fontSize[16]
};

// Migrated from globals.scss `.process-chip-1/4/7/10`, `-2/5/8/11`, `-3/6/9/12`
// (single owner, this file) — the 3-color cycle keyed by `index % 3`, replacing
// the 12 enumerated class names. Backgrounds have no exact token match, kept literal.
const processChipVariants: React.CSSProperties[] = [
    {color: colors.primary.main, backgroundColor: '#daefff'}, // primary.main — darker blue text meets WCAG AA on light-blue chip
    {color: colors.accent.orangeDarkest, backgroundColor: '#ffe2da'}, // accent.orangeDarkest — darker warm text meets WCAG AA on peach chip
    {color: colors.accent.goldDark, backgroundColor: '#ffedc2'} // accent.goldDark — darker gold text meets WCAG AA on cream chip
];

// Migrated from globals.scss `.latest-process-component .one-step-sub-heading`
// descendant override — `.one-step-sub-heading` itself stays global (shared with
// `platforms`/`TransportService`/`one-step-solution`, see that component's own comment).
const sxLatestProcessComponent = {
    '& .one-step-sub-heading': {
        lineHeight: '1.5 !important',
        letterSpacing: '0.00938em'
    }
};

// Migrated from globals.scss `.latest-process-content-wrapper`.
const sxContentWrapper = {
    textAlign: 'center'
};

// Migrated from globals.scss `.content-parent`.
const sxContentParent = {
    marginTop: '15px' // no exact spacing-token match
};

// Migrated from globals.scss `.one-step-grid-wrapper` (single owner, this file).
const sxOneStepGridWrapper = {
    marginTop: `${spacing[20]} !important`,
    paddingBottom: `${spacing[20]} !important`
} as const;

const LatestProcess = (props: any) => {
    const {processData, heading, subheading} = props;
    return (
        <MUIBox sx={sxLatestProcessComponent}>
            <MUIBox className="spectrum-header-wrapper solutions">
                <MUITypography className="spectrum-heading color-black" pt={5} component="h2">
                    {heading}
                </MUITypography>
                <MUIBox className={subheading !== undefined ? 'divder-wrapper' : ''}>
                    <hr className="divider-line" />
                </MUIBox>
                {subheading ? (
                    <MUIBox className="sub-heading-box">
                        <MUITypography className="spectrum-sub-heading color-black spacing">{subheading}</MUITypography>
                    </MUIBox>
                ) : null}
            </MUIBox>
            <MUIGrid container spacing={1} className="one-step-grid-wrapper" sx={sxOneStepGridWrapper}>
                {processData?.map((data: any, index: number) => (
                    <Fragment key={index}>
                        <MUIGrid item xs={12} sm={6} md={4} lg={4}>
                            <MUIBox sx={sxContentWrapper}>
                                <MUIBox>
                                    <DisplayImage
                                        src={data.img}
                                        alt={data.heading}
                                        height={80}
                                        width={80}
                                        priority={false}
                                        className="step-image"
                                    />
                                </MUIBox>
                                <Chip style={{...processChipStyle, ...processChipVariants[index % 3]}}>{data.chip}</Chip>
                                <MUIBox sx={sxContentParent}>
                                    <MUITypography className="one-step-content-heading" component="h3">
                                        {data.heading}
                                    </MUITypography>
                                    <p className="one-step-sub-heading data_links">{data.content ? parse(data.content) : ''}</p>
                                </MUIBox>
                            </MUIBox>
                        </MUIGrid>
                    </Fragment>
                ))}
            </MUIGrid>
        </MUIBox>
    );
};
export default memo(LatestProcess);
